<template>
  <filter-button
    :active="active"
    action="proposals/filter"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import FilterButton from '@sdk/components/Filters/Button.vue';

  export default {
    name: 'ProposalsApproved',
    components: {
      FilterButton,
    },
    computed: {
      ...mapState([
        'proposals',
      ]),

      active() {
        // eslint-disable-next-line no-underscore-dangle
        return this.proposals.list.filters._active;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-approved-filter {
  }
</style>
